import React from 'react';

import Image from '../../assets/img/service/icon-1-1.png';
import shapeImg from '../../assets/img/service/icon-shape.png';

const SingleCategory = (props) => {
  const { itemClass, iconImage, title, itemCount } = props;
  return (
    <div
      className={itemClass ? itemClass : 'it-categori-item z-index text-center'}
    >
      <div className="it-categori-icon mb-15 p-relative">
        <span>
          <img src={iconImage ? iconImage : Image} alt="" />
        </span>
        <div className="it-categori-icon-shape">
          <img src={shapeImg} alt="" />
        </div>
      </div>
      <h4 className="it-categori-title">{title ? title : 'Medicine'}</h4>
      <span>{itemCount ? itemCount : '5k+ Items'}</span>
    </div>
  );
};

export default SingleCategory;
